import React, { useEffect, useRef, useState } from "react";
import "./themeCricket.css";

const LiveMatchTrackerCricket = ({ scoreId, type, tabPosition }) => {
  const widgetRef = useRef(null);
  const [showLoader, setLoader] = useState(true);

  useEffect(() => {
    if (!scoreId) {
      console.warn("scoreId is undefined or null — widget not initialized.");
      return;
    }

    let checkSIRInterval = null;

    const loadScript = () => {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(
          'script[src="https://widgets.sir.sportradar.com/4e8b0c5dd1a1da96d801a7c1f8b1cbfc/widgetloader"]',
        );
        if (!existingScript) {
          const script = document.createElement("script");
          script.src =
            "https://widgets.sir.sportradar.com/4e8b0c5dd1a1da96d801a7c1f8b1cbfc/widgetloader";
          script.async = true;
          script.onload = () => resolve();
          script.onerror = () =>
            reject(new Error("Failed to load the SIR widget script."));
          document.body.appendChild(script);
        } else {
          resolve();
        }
      });
    };

    loadScript()
      .then(() => {
        const maxAttempts = 20;
        let attempts = 0;

        checkSIRInterval = setInterval(() => {
          attempts++;

          if (window.SIR && widgetRef.current) {
            clearInterval(checkSIRInterval);
            window.SIR("addWidget", widgetRef.current, "match.lmtPlus", {
              branding: {
                tabs: {
                  option: "icon",
                  iconPosition: "start",
                  variant: "fullWidth",
                  align: "center",
                },
              },
              pitchCustomBgColor: "#127635",
              disablePitchNoise: true,
              disablePitchStripes: true,
              disablePitchOverlay: true,
              disablePitchSpotlights: true,
              pitchLightStyle: false,
              layout: "single",
              momentum: "extended",
              collapseTo: "momentum",
              tabsPosition: "top",
              matchId: scoreId,
            });
          } else if (attempts >= maxAttempts) {
            clearInterval(checkSIRInterval);
            console.warn(
              "SIR widget failed to initialize after maximum attempts.",
            );
          }
        }, 300);
      })
      .catch((err) => {
        console.error("Script load error:", err);
      });

    return () => {
      if (checkSIRInterval) clearInterval(checkSIRInterval);
      if (widgetRef.current) {
        widgetRef.current.innerHTML = "";
      }
    };
  }, [scoreId]);

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 1500);
  }, []);

  return (
    <div
      className={`widgets ${type == "inner" ? "" : showLoader ? "" : "p-2"}`}
      style={{
        width: "100%",
        justifyContent: "center",
        position: ``,
      }}
    >
      {type == "inner" ? (
        ""
      ) : (
        <style>
          {`.sr-bb {
  border-radius: 8px;
}`}{" "}
        </style>
      )}

      <div className="w-100" style={{ position: `relative` }}>
        {!showLoader
          ? ""
          : type !== "inner" && (
              <div
                id="loading1"
                className="loading1"
                style={{ display: `block` }}
              >
                <div className="loading-box1">
                  <div className="loading-spinner"></div>
                </div>
              </div>
            )}
        <div
          className="sr-widget sr-widget-1"
          style={{
            borderRadius: type == "inner" ? "" : "8px",
          }}
          ref={widgetRef}
        >
          {/* Widget content will be injected here by the external script */}
        </div>
      </div>
    </div>
  );
};

export default LiveMatchTrackerCricket;
